import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

import { isEmpty } from "2g-utils-common";

export default function useNotifikaceUser({ username }) {
  return useDataLoader({
    url: DATA.notifikaceUser(username),
    method: "get",
    lazy: isEmpty(username)
  });
}
